import React from "react";
import inviteImage from "~/images/invite_or_find_illustration.png";

const ProcessingFileModal = ({ processingProgress }) => {
  const files = processingProgress ?? [];
  const multiple = files.length > 1;

  const percent = files.length
    ? Math.round(files.reduce((sum, file) => sum + file.percent, 0) / files.length)
    : 0;

  return (
    <div className="modal__background">
      <div className="modal__body modal__body--no-side-padding">
        <div className="flex flex-column align-items-center mb--32">
          <div className="modal__body__title">
            {multiple ? `Reprocessing ${percent}%` : `Processing ${percent}%`}
          </div>
        </div>
        <div className="flex justify-content-center modal__body__spotlight mb--32">
          <img src={inviteImage} alt="" height={140} width={180} />
        </div>
        <div className="flex flex-column align-items-center">
          <div className="modal__body__subtitle">
            Please wait a moment while we{" "}
            {multiple ? "reprocess files with your new mapping changes." : "process your data."}
          </div>
        </div>
        <div className="modal__body__container">
          <div className="progress_bar__container">
            <div className="progress_bar__fill" style={{ width: `${percent}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingFileModal;
